<template>
  <div class="payment_wrapper">
    <div class="amount_wrapper">
      <div
        v-for="(data, index) in amountList"
        class="amount"
        :class="{ active: amountSelect == data }"
        :key="index"
        @click="
          amountSelect = data;
          amountInput = null;
        "
      >
        $ {{ data }}
      </div>
    </div>
    <div class="input_wrapper">
      <span>or</span>
      <a-input v-model:value="amountInput" class="amount_input" addon-before="$" />
    </div>
    <div class="third_pay_wrapper">
      <div class="choose_title">Please choose</div>
      <div class="btn_wrapper">
        <span class="pay_btn" @click="handleInitPaypalModal">
          <img class="pay_img" src="@/assets/images/paypal.svg" />
        </span>
        <span class="pay_btn" @click="zelleModal = true">
          <img class="zelle_img" src="@/assets/images/zelle.svg" />
        </span>
        <span class="pay_btn" @click="receiptInfoModal = true">
          <img class="check_img" src="@/assets/images/check.svg" />
        </span>
      </div>
      <div class="checkbox_wrapper">
        <a-checkbox v-model:checked="isCheckbox" @change="handleCheckboxChange" />
        <span class="tips">Receive a receipt after making a contribution</span>
      </div>
    </div>
  </div>
  <a-modal class="receipt_modal" v-model:open="receiptFormModal" :closable="false" :footer="null" :width="680">
    <div class="modal_title">Please enter your contact information to receive a donation receipt.</div>
    <a-form ref="formRef" class="receipt_form" :model="formState">
      <a-form-item
        name="firstName"
        :rules="[{ required: true, message: 'Please enter first name' }]"
        class="receipt_form_item"
      >
        <div class="form_label">First Name</div>
        <a-input v-model:value="formState.firstName" placeholder="First Name" autocomplete="off"></a-input>
      </a-form-item>
      <a-form-item
        name="lastName"
        :rules="[{ required: true, message: 'Please enter last name' }]"
        class="receipt_form_item"
      >
        <div class="form_label">Last Name</div>
        <a-input v-model:value="formState.lastName" placeholder="Last Name" autocomplete="off"></a-input>
      </a-form-item>
      <a-form-item
        name="gender"
        :rules="[{ required: true, message: 'Please enter gender' }]"
        class="receipt_form_item"
      >
        <div class="form_label">Gender Selection</div>
        <a-select v-model:value="formState.gender" placeholder="Please select gender">
          <a-select-option v-for="(data, index) in genderList" :key="index" :value="data.value">
            {{ data.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        name="email"
        :rules="[{ required: true, message: 'Please enter mail' }]"
        class="receipt_form_item mail_item"
      >
        <div class="form_label">Mail</div>
        <a-input
          v-model:value="formState.email"
          placeholder="Please enter your email address"
          autocomplete="off"
        ></a-input>
      </a-form-item>
    </a-form>
    <div class="form_btn_group">
      <button class="form_btn btn_skip" @click="handleSkipAction">Skip</button>
      <button class="form_btn btn_done" @click="handleReceiptInit" :disabled="isBtnDisabled">Done</button>
    </div>
  </a-modal>
  <a-modal class="receipt_modal" v-model:open="receiptInfoModal" :closable="false" :footer="null" :width="680">
    <img class="receipt_bg_top" src="@/assets/images/receipt_bg_top.svg" />
    <div class="info_title">Check</div>
    <div class="info_wrapper">
      <div class="info_content" style="flex: 100%;">
        <div class="label">Payee</div>
        <div class="info">Gleaning Fields Foundation</div>
      </div>
      <div class="info_content">
        <div class="label">Mailing Address: <span class="info">12506 128th Lane NE, Kirkland WA 98034</span></div>
        <div class="label">Contact Phone Number: <span class="info">909-210-8623</span></div>
      </div>
    </div>
    <div class="info_title" style="margin-top: 24px;">Wire</div>
    <div class="info_wrapper">
      <div class="info_content" style="flex: 1;">
        <div class="info">BANK OF AMERICA 10555 NE 8th St, Bellevue, WA 98004</div>
      </div>
      <div class="info_content">
        <div class="label">Swift Code: <span class="info">BOFAUS3N</span></div>
        <div class="label">Routing Number: <span class="info">026009593 (Wire) 125000024 (Paper & ACH)</span></div>
        <div class="label">Account Number: <span class="info">20217915</span></div>
        <div class="label">Account Name: <span class="info">GLEANING FIELDS FOUNDATION</span></div>
      </div>
    </div>
    <img class="receipt_bg_bottom" src="@/assets/images/receipt_bg_bottom.svg" />
  </a-modal>
  <a-modal class="receipt_modal paypal_modal" v-model:open="paypalModal" :closable="false" :footer="null" :width="400">
    <div v-if="qrCodeUrl" class="paypal_qrcode_container">
      <img :src="qrCodeUrl" alt="qrcode" />
    </div>
    <div class="paypal_qrcode_tips">
      <img src="@/assets/images/scan.svg" />
      Scan to donate via the PayPal app
    </div>
    <div class="paypal_divide_container">
      <span class="paypal_divide"></span>
      <span class="paypal_divide_text">or</span>
      <span class="paypal_divide"></span>
    </div>
    <div class="paypal_button_tips">Donate with your account and password</div>
    <div class="paypal_button_container"></div>
  </a-modal>
  <a-modal class="receipt_modal zelle_modal" v-model:open="zelleModal" :closable="false" :footer="null" :width="600">
    <img class="zelle_title_img" src="@/assets/images/zelle.svg" />
    <div class="zelle_title">Transfer money using the Zelle App</div>
    <div class="zelle_content">
      <img class="zelle_bg" src="@/assets/images/zelle_bg.svg" />
      <div class="zelle_tips">The receiving account details are as follows</div>
      <img class="zelle_arrow" src="@/assets/images/arrow_down.svg" />
      <div class="zelle_account">{{ zelleAccount }}</div>
      <img class="zelle_copy" src="@/assets/images/copy.svg" @click="handleCopyContact(zelleAccount)" />
    </div>
  </a-modal>
</template>

<script setup>
import { message } from 'ant-design-vue';
import QRCode from 'qrcode';
import { ref, onMounted, reactive, handleError, toRaw, defineProps, watch } from 'vue';

import { fetchGenderList, submitReceipt, fetchProjectDetail, createPaypalOrder } from '@/api/common';

const props = defineProps({
  dedicateId: {},
});
const receiptFormModal = ref(false);
const receiptInfoModal = ref(false);
const paypalModal = ref(false);
const zelleModal = ref(false);
const formRef = ref(null);
const formState = reactive({
  orderNo: '',
  firstName: '',
  lastName: '',
  email: '',
  gender: null,
});
const amountSelect = ref(null);
const amountInput = ref(null);
const amountList = ref([25, 50, 100, 200, 500]);
const qrCodeUrl = ref('');
const generateQRCode = async (text) => {
  try {
    qrCodeUrl.value = await QRCode.toDataURL(text, {
      width: 128,
      margin: 0,
      color: {
        dark: '#000000',
        light: '#ffffff',
      },
    });
  } catch (err) {
    message.error('Failed to generate QR code');
  }
};

watch(amountInput, (newValue) => {
  if (newValue !== null) {
    amountSelect.value = null;
  }
});

const getProjectDetail = (newVal) => {
  fetchProjectDetail(newVal).then((res) => {
    if (res.code == 200 && res.data.dedicateAmountsList) {
      amountList.value = res.data.dedicateAmountsList;
    }
  });
};

watch(
  () => props.dedicateId,
  (newVal) => {
    if (newVal) {
      getProjectDetail(newVal);
    }
  },
  { immediate: true }
);
const isCheckbox = ref(false);
const genderList = ref([]);
const isBtnDisabled = ref(false);
const zelleAccount = ref('office@gffglobalmissions.org');

const handleCheckboxChange = (e) => {
  if (e.target.checked) {
    receiptFormModal.value = true;
    if (formRef.value) {
      formRef.value.resetFields();
    }
  }
};
const getGenderList = () => {
  fetchGenderList().then((res) => {
    if (res.code == 200) {
      genderList.value = res.data;
    }
  });
};
const handleReceiptInit = () => {
  formRef.value.validate().then(() => {
    receiptFormModal.value = false;
    isCheckbox.value = true;
  });
};
const handleReceiptSubmit = () => {
  submitReceipt(toRaw(formState)).then((res) => {
    if (res.code != 200) {
      message.error(res.msg);
    }
  });
};
const handleSkipAction = () => {
  receiptFormModal.value = false;
  isCheckbox.value = false;
};
const loadPayPalScript = () => {
  return new Promise((resolve) => {
    if (window.paypal) {
      resolve();
    } else {
      const script = document.createElement('script');
      script.src = 'https://www.paypal.com/sdk/js?client-id=' + process.env.VUE_APP_PAYPAL_CLIENT_ID + '&currency=USD';
      script.onload = () => resolve();
      document.body.appendChild(script);
    }
  });
};
const renderPayPalButton = () => {
  document.querySelector('.paypal_button_container').innerHTML = '';
  window.paypal
    .Buttons({
      style: {
        layout: 'vertical',
        color: 'gold',
        shape: 'rect',
        label: 'paypal',
      },
      createOrder: (data, actions) => {
        return actions.order.create({
          purchase_units: [
            {
              amount: {
                value: (amountSelect.value || amountInput.value).toString(),
              },
            },
          ],
        });
      },
      onApprove: (data, actions) => {
        return actions.order.capture().then((details) => {
          paypalModal.value = false;
          message.success('Transaction completed by ' + details.payer.name.given_name);
          formState.orderNo = details.id;
          if (isCheckbox.value) {
            handleReceiptSubmit();
          }
        });
      },
      onError: (err) => {
        handleError(err);
      },
    })
    .render('.paypal_button_container');
};
const handleInitPaypalModal = () => {
  if (amountInput.value || amountSelect.value) {
    paypalModal.value = true;
    createPaypalOrder({
      amount: amountSelect.value || amountInput.value,
      projectId: props.dedicateId,
      currency: 'USD',
      ...(isCheckbox.value && {
        firstName: formState.firstName,
        lastName: formState.lastName,
        email: formState.email,
        gender: formState.gender,
      }),
    }).then((res) => {
      if (res.code == 200) {
        generateQRCode(res.data.app_url);
      }
    });
    loadPayPalScript().then(renderPayPalButton);
  } else {
    message.error('Please select the amount first');
  }
};
const handleCopyContact = (text) => {
  if (navigator.clipboard) {
    navigator.clipboard
      .writeText(text)
      .then(() => message.success('Copy successful'))
      .catch(() => {
        message.error('Copy Failed');
      });
  } else {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      message.success('Copy successful');
    } catch (err) {
      message.error('Copy Failed');
    } finally {
      document.body.removeChild(textarea);
    }
  }
};

onMounted(() => {
  getGenderList();
});
</script>

<style lang="less" scoped>
.payment_wrapper {
  .amount_wrapper {
    display: flex;
    gap: 12px;
    margin-bottom: 24px;
    .amount {
      width: 80px;
      color: #f78335;
      border: 1px solid #f78335;
      background: #ffecdd;
      border-radius: 6px;
      padding: 10px 0;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      &.active,
      &:hover {
        color: #ffffff;
        background: #ffaa66;
        border-color: #f78335;
      }
    }
  }
  .input_wrapper {
    display: flex;
    margin-bottom: 24px;
    align-items: center;
    .amount_input {
      display: inline-block;
      width: 145px;
      margin-left: 12px;
    }
  }
  .third_pay_wrapper {
    .choose_title {
      color: #999999;
      margin-bottom: 12px;
    }
    .btn_wrapper {
      display: flex;
      gap: 16px;
      margin: 16px auto;
      align-items: center;
      flex-wrap: wrap;
      .pay_btn {
        border-radius: 6px;
        min-width: 130px;
        height: 48px;
        text-align: center;
        padding: 10px 20px;
        border: 1px solid #333333;
        display: flex;
        justify-content: center;
        cursor: pointer;
        .zelle_img {
          width: 80px;
        }
        .check_img {
          width: 130px;
        }
      }
      .divide {
        color: #d8d8d8;
      }
      .check_text {
        color: #f78335;
        cursor: pointer;
        img {
          vertical-align: text-top;
          margin-right: 4px;
        }
      }
    }
  }
  .checkbox_wrapper {
    color: #999999;
    .tips {
      margin-left: 12px;
      cursor: pointer;
    }
  }
}
</style>

<style lang="less">
.receipt_modal {
  .receipt_bg_top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .ant-modal-content {
    padding: 48px 32px;
  }
  .modal_title {
    font-size: 16px;
    font-weight: bold;
    margin: 25px auto;
    text-align: center;
  }
  .receipt_form {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    .receipt_form_item {
      width: calc(50% - 10px);
      margin-bottom: 0;
      .form_label {
        color: #3d3d3d;
        margin-bottom: 8px;
      }
      .ant-input {
        border: 1px solid #333333;
        height: 40.15px;
        border-radius: 6px;
        color: #3d3d3d;
        &.ant-input-status-error {
          border-color: #ff4d4f;
        }
      }
      .ant-select {
        &.ant-select-status-error {
          .ant-select-selector {
            border-color: #ff4d4f;
          }
        }
        .ant-select-selector {
          border: 1px solid #333333;
          height: 40.15px;
          border-radius: 6px;
          color: #3d3d3d;
          box-shadow: none !important;
        }
        &:hover,
        &:focus,
        &.ant-select-focused {
          .ant-select-selector {
            border-color: #333333;
          }
        }
        .ant-select-selection-placeholder,
        .ant-select-selection-item {
          line-height: 40.15px;
        }
      }
      &.mail_item {
        width: 100%;
      }
    }
  }
  .form_btn_group {
    display: flex;
    gap: 16px;
    margin: 32px auto 12px;
    .form_btn {
      width: calc(50% - 8px);
      border-radius: 100px;
      text-align: center;
      font-size: 16px;
      padding: 18px;
      font-weight: bold;
      height: 48px;
      padding: 10px;
      cursor: pointer;
      box-shadow: none;
      outline: none;
      border: none;
      &.btn_skip {
        color: #3d3d3d;
        background: #ebebeb;
      }
      &.btn_done {
        color: #ffffff;
        background: #05644f;
      }
    }
  }
  .info_title {
    font-weight: bold;
    border-bottom: 1px solid #d8d8d8;
    padding-bottom: 12px;
    .copy_icon {
      margin-left: 8px;
      cursor: pointer;
    }
  }
  .info_wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    .info_content {
      flex: 2;
      margin-top: 16px;
      .label {
        color: #888888;
      }
      .info {
        color: #3d3d3d;
      }
    }
  }
  .receipt_bg_bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
.paypal_modal {
  .ant-modal-content {
    padding: 32px;
    color: #999999;
    text-align: center;
    .paypal_qrcode_tips {
      img {
        width: 16px;
        height: 16px;
        margin: -4px 4px 0 0;
      }
    }
    .paypal_qrcode_container {
      margin-bottom: 20px;
      img {
        padding: 12px;
        border: 1px solid #999999;
        border-radius: 8px;
      }
    }
    .paypal_divide_container {
      margin: 20px 0;
      display: flex;
      align-items: center;
      .paypal_divide_text {
        margin: 0 12px;
      }
      .paypal_divide {
        flex: 1;
        height: 1px;
        background: #d8d8d8;
      }
    }
    .paypal_button_tips {
      margin-bottom: 24px;
    }
  }
}
.zelle_modal {
  .ant-modal-content {
    padding: 32px 32px 0 32px;
    text-align: center;
    .zelle_title_img {
      width: 120px;
      margin: 0 auto 20px;
      display: block;
    }
    .zelle_title {
      color: #999999;
      margin-bottom: 20px;
    }
    .zelle_content {
      height: 330px;
      position: relative;
      padding-top: 60px;
      overflow: hidden;
      .zelle_bg {
        width: 360px;
        height: auto;
        position: absolute;
        top: 0;
        left: calc(50% - 180px);
      }
      .zelle_tips {
        color: #7f28d1;
        position: relative;
        width: 200px;
        margin: 0 auto;
      }
      .zelle_arrow {
        position: relative;
        margin: 20px 0;
      }
      .zelle_account {
        position: relative;
        border-radius: 6px;
        background: #ffffff;
        box-sizing: border-box;
        border: 1px solid #999999;
        padding: 16px 30px;
        width: 280px;
        margin: 0 auto 20px;
      }
      .zelle_copy {
        position: relative;
        cursor: pointer;
      }
    }
  }
}
</style>
